var React = require('react');

function FacebookInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.25 5.25V3.687c0-.705.156-1.062 1.251-1.062h1.374V0H5.582C2.773 0 1.846 1.288 1.846 3.5v1.75H0v2.625h1.846v7.875h3.4V7.875h2.313l.312-2.625z","fill":"currentColor","data-name":"Group 284"}));
}

FacebookInline.defaultProps = {"viewBox":"0 0 7.875 15.75"};

module.exports = FacebookInline;

FacebookInline.default = FacebookInline;
